// leadStorage.ts

export const LEAD_KEYS = {
  name: 'name',
  lastName: 'lastName',
  email: 'email',
  mobileNumber: 'mobileNumber',
  webUser: 'webUser',
  plan: 'plan',
  products: 'products',
  environment: 'environment',
  mobileDevice: 'mobileDevice',
  resident: 'resident',
  age: 'age',
  externalVendor: 'externalVendor',
  accountDeletionReason: 'accountDeletionReason',
  accountName1: 'accountName1',
  userId: 'userId',
  dob: 'dob',
  genderZoho: 'genderZoho',
  utmCampaign: 'utmCampaign',
  utmMedium: 'utmMedium',
  utmSource: 'utmSource',
  referralUrl: 'referralUrl',
  formName: 'formName',
  firstVisit: 'firstVisit',
  paidDate: 'paidDate',
  couponCode: 'couponCodeUsed',
  os: 'os',
} as const;


export const saveLeadField = (key: string, value: string | null) => {
  if (value !== null && value !== undefined) {
    localStorage.setItem(key, value);
  }
};


export const saveLeadBoolField = (key: string, value: boolean | null) => {
  if (value !== null && value !== undefined) {
    localStorage.setItem(key, value.toString());
  }
};


export const saveLeadListField = (key: string, values: string[] | null) => {
  if (values !== null && values !== undefined) {
    try {
      const str = JSON.stringify(values);
      localStorage.setItem(key, str);
    } catch {
      // If JSON.stringify fails or localStorage is unavailable, do nothing.
    }
  }
};


export const getLeadListField = (key: string): string[] | null => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((x) => typeof x === 'string')) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
};


export const getLeadField = (key: string): string | null => {
  return localStorage.getItem(key);
};

export const getLeadBoolField = (key: string): boolean | null => {
  const value = localStorage.getItem(key);
  return value === null ? null : value === 'true';
};


export interface LeadDraft {
  [key: string]: string | string[] | null;
}


export const buildLeadInput = (): LeadDraft => {
  const input: LeadDraft = {};

  Object.values(LEAD_KEYS).forEach((key) => {
    if (key === LEAD_KEYS.products) {
      input[key] = getLeadListField(key);
    } else {
      input[key] = getLeadField(key);
    }
  });

  return input;
};


export const clearLeadDraft = () => {
  Object.values(LEAD_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
};
